export default "__VITE_ASSET__aC7GEOLV__"